import gql from 'graphql-tag'

export const GET_CLIENTS_PAGINATION_QUERY = gql`
  query GetClientsPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getClients (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
          id
          fullName
        createdAt
        citizenshipId
        citizenship {
          id
          icon
        }
        telNumber
        profilePhotoX64 {
          id
          fullUri
        }
      }
    }
  }
`
